<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Urlaube
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          Mitarbeiterliste
        </h5>

        <Search
            :filters="filters"
            :loading="isSearching"
            :officeDropdown="officeDropdown"
            :lastNameDropdown="lastNameDropdown"
            @search="getUsers"/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getUsers"/>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>
                <span>Mitarbeiternummer</span>
              </th>
              <th>
                <span>Extern/Intern</span>
              </th>
              <th>
                Vorname
              </th>
              <th>
                Nachname
              </th>
              <th>
                Rechte
              </th>
              <th class="text-center">
                Offene Urlaubsanträge
              </th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">
                {{ $t('general.actions') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(user) in users.data" :key="user.id">
              <td>
                {{ user?.employeeNumber }}
              </td>
              <td>
                {{ user?.engagementTypeTranslation }}
              </td>
              <td>
                {{ user?.firstName }}
              </td>
              <td>
                {{ user?.lastName }}
              </td>
              <td>
                {{ user?.userAccessRightsTranslation }}
              </td>
              <td class="text-center">
                  <span v-if="user?.numberOfPendingHoliday > 0"
                        style="background-color: orange;
                        color: white;
                        padding: 7px 10px;
                        border-radius: 50%;">
                      {{ user?.numberOfPendingHoliday }}
                  </span>
              </td>
              <td class="text-right">
                <button class="btn btn-primary"
                        @click="router.push({name: 'holidayUserOverview', params: {overviewUserId: user?.id} })">
                  Übersicht
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="users?.pagination?.total_pages > 1"
            :totalPages="users?.pagination?.total_pages"
            :currentPage="users?.pagination?.current_page"
            @pagechanged="getUsers"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import holidayService from '@/api/Holiday';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { getOfficeDropdown, getUsersForHrOverviewDropdown } from '@/shared/dropdowns';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import Search from '@/views/App/Holiday/UserList/Search.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const piniaEnumsState = piniaEnumsStore();

const { t }    = useI18n();
const getEnums = computed(() => piniaEnumsState.enums);
const users    = ref([]);
const filters  = ref({
  officeId: '',
  userId: '',
  orderBy: 'DESC',
  sortBy: '',
});

const showModal        = ref(false);
const isSearching      = ref(false);
const isLoaded         = ref(false);
const officeDropdown   = ref([]);
const lastNameDropdown = ref([]);

async function getUsers(page = 1, perPage, passedFilters) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = users.value?.pagination?.items_per_page;

  try {
    const { data } = await holidayService.getUsers({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    users.value       = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await Promise.all([
    getOfficeDropdown(officeDropdown, t),
    getUsersForHrOverviewDropdown(lastNameDropdown),
    getUsers(),
  ]);

  isLoaded.value = true;
});


</script>

<style scoped>

</style>